module.exports = __webpack_public_path__ + "img/coupon-popup-item-empty.eea10e5d.png";